import type { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { formatNumber } from '@wix/da-shared-react/pkg/utils/formatting';
import Flex from '@wix/da-ds/pkg/Flex';
import ProductListItem, { Props } from '../ProductListItem';
import PcpPriceEdit from '../../../StudioDeviationList/_partials/PcpPriceEdit';
import StatItem from '../../../StudioDeviationList/_partials/StatItem';

const PcpListItem: FC<Props> = ({ deviation, offset, ...props }) => {
  const { t } = useTranslation();
  const downloadCount = deviation.pcp?.salesCount ?? 0;
  const viewCount = deviation.stats?.views ?? 0;
  const statsAndControls = (
    <Flex gap={24} alignItems="center">
      <PcpPriceEdit deviation={deviation} />
      <StatItem
        title={t('studio.products.pcp.stats.downloadsCount')}
        value={formatNumber(downloadCount)}
        linkTo={
          downloadCount > 0
            ? Url.customerDashboard(deviation.pcp?.subproductId)
            : undefined
        }
      />
      <StatItem
        title={t('studio.products.pcp.stats.viewsCount')}
        value={formatNumber(viewCount)}
      />
    </Flex>
  );
  return (
    <ProductListItem
      deviation={deviation}
      offset={offset}
      bottomSlot={statsAndControls}
      {...props}
    />
  );
};
PcpListItem.displayName = 'PcpListItem';

export default PcpListItem;
